// "0 dias", "1 dia", "3 dias"; sem valor, "-"
export function deliveryDays(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
        return '-'
    }

    const days = Number(value)

    if (!Number.isFinite(days)) {
        return '-'
    }

    return `${days} ${days === 1 ? 'dia' : 'dias'}`
}
